import React from 'react';

const CheckMarkWhiteIcon = () => {
	return (
		<svg
			fill='none'
			height='31'
			viewBox='0 0 30 31'
			width='30'
		>
			<path
				clipRule='evenodd'
				d='M25.0899 8.43934C25.6367 9.02513 25.6367 9.97487 25.0899 10.5607L13.8899 22.5607C13.3432 23.1464 12.4568 23.1464 11.9101 22.5607L4.91005 15.0607C4.36332 14.4749 4.36332 13.5251 4.91005 12.9393C5.45678 12.3536 6.34322 12.3536 6.88995 12.9393L12.9 19.3787L23.1101 8.43934C23.6568 7.85355 24.5432 7.85355 25.0899 8.43934Z'
				fill='white'
				fillRule='evenodd'
			/>
		</svg>
	);
};

export default CheckMarkWhiteIcon;
